import axios from 'axios';
import { baseURL } from './api';

const apiVersion = 'v2';
const path = process.env.REACT_APP_BASE_URL + '/api/';

class CompanyService {
  static baseURL = baseURL;

  static resourcePath = path || '';

  constructor(api, demo = false, baseURLOverride) {
    this.api = api;
    this.demo = demo;
    this.baseURL = baseURLOverride;
  }

  getBaseURL = () => {
    return this.baseURL || CompanyService.resourcePath || CompanyService.baseURL;
  };

  getPaginateOptions = options => {
    return JSON.stringify(options || { page: 1, limit: 10 });
  };

  async getCompaniesByGroupApi(groupID) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companyGroups/${groupID}/companies`,
      { headers },
    );
    return data;
  }

  async getPriBoxesByCompany(cid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data={} } = await axios.get(`${this.getBaseURL()}${apiVersion}/companies/${cid}/getPriBoxesByCompany`, {
      headers,
    });
    return data;
  }

  async getSipBoxesByCompany(cid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data = {} } = await axios.get(`${this.getBaseURL()}${apiVersion}/companies/${cid}/getSipBoxesByCompany`, {
      headers,
    });
    return data;
  }

  // GET /api/companies
  async getCompanies(
    paginateOptions,
    disablePaginate = 'no',
    type = '',
    getDeleted = global.deleteMode,
    onlyNames,
  ) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    if (disablePaginate === 'yes') {
      const { data } = await axios.get(
        // eslint-disable-next-line max-len
        `${this.getBaseURL()}${apiVersion}/companies/?disablePaginate=${disablePaginate}&type=${type}&getDeleted=${getDeleted}&onlyNames=${onlyNames}`,
        { headers },
      );
      return data;
    }
    const options = this.getPaginateOptions(paginateOptions);

    const { data } = await axios.get(
      // eslint-disable-next-line max-len
      `${this.getBaseURL()}${apiVersion}/companies/?paginateOptions=${options}&type=${type}&getDeleted=${getDeleted}&onlyNames=${onlyNames}`,
      { headers },
    );
    return data;
  }

  // GET /api/id/companyGroups
  async getCompanyGroup(cid) {
    if (!cid) return;
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companies/${cid}/companyGroups`,
      { headers },
    );
    return data;
  }

  async getCompanyGroups(
    paginateOptions,
    paginateResult,
    getDeleted = global.deleteMode,
    onlyName,
  ) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companyGroups?paginateResult=${false}&paginateOptions=${options}&getDeleted=${getDeleted}&onlyName=${onlyName}`,
      { headers },
    );
    return data;
  }

  async getEnterpriseAdmins(paginateOptions, filters) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);
    const search = filters.name ? `name=${filters?.name}` : `company=${filters?.company}`;
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/enterprise-group?paginateResult=${false}&paginateOptions=${options}&${search}`,
      { headers },
    );
    return data;
  }

  async addEnterpriseAdmins(body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(`${this.getBaseURL()}${apiVersion}/enterprise-group`, body, {
      headers,
    });
    return data;
  }

  // GET reqest to get the list of company group names to show in drop down
  async companyGroupListUnPaginatedApi() {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companyGroups?paginateResult=false`,
      { headers },
    );
    return data;
  }
  //  GET /companies/autocomplete/<pattern>
  async filterCompanies(company, paginateOptions, getDeleted = global.deleteMode) {
    const options = this.getPaginateOptions(paginateOptions);
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companies/autocomplete/${company}?paginateOptions=${options}&getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }

  // POST /api/companies
  async addCompany(company) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(`${this.getBaseURL()}${apiVersion}/companies`, company, {
      headers,
    });
    return data;
  }

  async addCompanyGroup(company) {
    let groupSuperAdmins = [];
    let groupManagers = [];
    let managedCompanies = [];

    let body = {};
    var option = company;

    if (option.groupSuperAdmins) {
      option.groupSuperAdmins.forEach((i, idx) => {
        groupSuperAdmins.push(i.email._id || i._id);
        if (option.groupSuperAdmins.length - 1 === idx) {
          body['groupSuperAdmins'] = groupSuperAdmins;
        }
      });
    }

    if (option.groupManagers) {
      option.groupManagers.forEach((i, idx) => {
        groupManagers.push(i.email._id || i._id);
        if (option.groupManagers.length - 1 === idx) {
          body['groupManagers'] = groupManagers;
        }
      });
    }

    if (option.managedCompanies) {
      option.managedCompanies.forEach((item, idx) => {
        managedCompanies.push(item._id || item.suggestion._id);
        if (option.managedCompanies.length - 1 === idx) {
          body['managedCompanies'] = managedCompanies;
        }
      });
    }

    body['name'] = company.name;
    body['company'] = company.company;
    body['managedCompanies'] = managedCompanies;
    body['groupSuperAdmins'] = groupSuperAdmins;
    body['groupManagers'] = groupManagers;
    body['hostTag'] = company.hostTag;
    body['notificationMails'] = company.notificationMails;

    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(`${this.getBaseURL()}${apiVersion}/companyGroups`, body, {
      headers,
    });
    return data;
  }

  async addEnterpriseGroup(company) {
    const body = {
      name: company.name,
      managementCompany: company.company || '',
    };

    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(`${this.getBaseURL()}${apiVersion}/enterprise-group`, body, {
      headers,
    });
    return data;
  }

  async updateCompanyGroup(id, company) {
    let groupSuperAdmins = [];
    let managedCompanies = [];
    let groupManagers = [];
    let supportEngineers = [];
    let body = {};
    var option = company;

    if (option.groupSuperAdmins) {
      body['groupSuperAdmins'] = [];
      option.groupSuperAdmins.forEach((i, idx) => {
        groupSuperAdmins.push(i.email._id || i._id);
        if (option.groupSuperAdmins.length - 1 === idx) {
          body['groupSuperAdmins'] = groupSuperAdmins;
        }
      });
    }

    if (option.groupManagers) {
      body['groupManagers'] = [];
      option.groupManagers.forEach((i, idx) => {
        groupManagers.push(i.email._id || i._id);
        if (option.groupManagers.length - 1 === idx) {
          body['groupManagers'] = groupManagers;
        }
      });
    }

    if (option.managedCompanies) {
      body['managedCompanies'] = [];
      option.managedCompanies.forEach((item, idx) => {
        managedCompanies.push(item._id || item.suggestion._id);
        if (option.managedCompanies.length - 1 === idx) {
          body['managedCompanies'] = managedCompanies;
        }
      });
    }

    if (option.supportEngineers) {
      body['supportEngineers'] = [];
      option.supportEngineers.forEach((item, idx) => {
        supportEngineers.push(item.email._id || item._id);
        if (option.supportEngineers.length - 1 === idx) {
          body['supportEngineers'] = supportEngineers;
        }
      });
    }

    if (company.name) body['name'] = company.name;
    body['company'] = company.company;
    body['hostTag'] = company.hostTag;
    body['notificationMails'] = company.notificationMails;

    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/companyGroups/${id}`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async updateEnterpriseAdmin(body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(`${this.getBaseURL()}${apiVersion}/enterprise-group`, body, {
      headers,
    });
    return data;
  }

  // POST /api/v2/companies/5d8be3b1edc4e7090804aebb/logo
  async addCompanyLogo(id, files) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/companies/${id}/logo`,
      files,
      {
        headers,
      },
    );
    return data;
  }

  // companyRouter.get(`/:id/logo`
  async getLogo(id) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/companies/${id}/logo`, {
      headers,
    });

    return data;
  }

  // PUT /api/companies/:id {status=STATUS}
  async setCompanyStatus(id, status = false) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    return await axios.put(
      `${this.getBaseURL()}${apiVersion}/companies/${id}`,
      { enabled: status },
      { headers },
    );
  }

  // DELETE /api/companies/:id
  async deleteCompany(id, hardDelete = global.deleteMode ? 'yes' : 'no') {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.delete(
      `${this.getBaseURL()}${apiVersion}/companies/${id}?hardDelete=${hardDelete}`,
      {
        headers,
      },
    );
    return data;
  }

  async deleteCompanyGroup(id, hardDelete) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.delete(
      `${this.getBaseURL()}${apiVersion}/companyGroups/${id}?hardDelete=${hardDelete}`,
      {
        headers,
      },
    );
    return data;
  }

  // PUT /api/companies/:id
  async updateCompany(id, companyData) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/companies/${id}`,
      companyData,
      { headers },
    );
    return data;
  }

  // recover company
  async onRecover(companyID) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const data = await axios.patch(
      `${this.getBaseURL()}${apiVersion}/companies/${companyID}`,
      {
        deleted: false,
      },
      { headers },
    );
    return data;
  }

  // recover company group
  async onRecoverCompanyGroup(companyID) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const data = await axios.patch(
      `${this.getBaseURL()}${apiVersion}/companyGroups/${companyID}`,
      {
        deleted: false,
      },
      { headers },
    );
    return data;
  }

  // {{BASE_URL}}/companies/:id/emailTemplates/
  async getTemplateEmailList(cid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companies/${cid}/emailTemplates`,
      {
        headers,
      },
    );
    return data;
  }

  // {{BASE_URL}}/companies/:id/emailTemplates/
  async getRowTemplate(cid, tid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companies/${cid}/emailTemplates/${tid}`,
      {
        headers,
      },
    );
    return data;
  }

  // companyRouter.post('/:id/emailTemplates', async (req, res) => {
  async addTemplate(cid, templateName, text) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const body = {
      templateName,
      text,
    };

    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/companies/${cid}/emailTemplates`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  // {{BASE_URL}}/companies/:id/emailTemplates/:tid
  async updateTemplate(cid, tid, templateName, text) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const body = {
      templateName,
      text,
    };

    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/companies/${cid}/emailTemplates/${tid}`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  // {{BASE_URL}}/companies/:id/emailTemplates/:tid
  async deleteTemplate(cid, tid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const { data } = await axios.delete(
      `${this.getBaseURL()}${apiVersion}/companies/${cid}/emailTemplates/${tid}`,
      {
        headers,
      },
    );
    return data;
  }

  // {{BASE_URL}}/companies/:id/emailTemplates/:tid
  async applyTemplate(cid, tid, pid, text) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const body = {
      pid,
      text,
    };

    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/companies/${cid}/emailTemplates/${tid}`,
      body,
      {
        headers,
      },
    );
    return data;
  }
  async getCompanyGroupByUser(cid, userId) {
    if (!cid) return;
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companies/${cid}/companyGroupsMasterOrUser`,
      {
        headers,
        params: { userId },
      }
    );
    return data;
  }
  async getUserCompanyGroup(uid) {
    if (!uid) return;
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/users/${uid}/userCompnayGroups`,
      { headers },
    );
    return data;
  }
}

export default CompanyService;
